export class RequestPasswordUpdateOTP {
  public email?: string | null;
  public userId?: number | null;

  constructor(obj: any) {
    Object.assign(this, obj);
  }
}
